var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFog(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4065_35270)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.625 5.75001L3.0625 4.31251C4.1875 3.62501 5.625 3.68751 6.6875 4.37501L8.125 5.31251C9.25 6.06251 10.75 6.06251 11.9375 5.31251L13.3125 4.37501C14.4375 3.62501 15.8125 3.62501 16.9375 4.31251L19.375 5.75001",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.625 16L3.0625 14.5625C4.1875 13.875 5.625 13.9375 6.6875 14.625L8.125 15.625C9.25 16.375 10.75 16.375 11.9375 15.625L13.375 14.6875C14.5 13.9375 15.875 13.9375 17 14.625L19.4375 16.0625",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.625 10.875L3.0625 9.43751C4.1875 8.75001 5.625 8.81251 6.6875 9.50001L8.125 10.4375C9.25 11.1875 10.75 11.1875 11.9375 10.4375L13.375 9.50001C14.5 8.75001 15.875 8.75001 17 9.43751L19.4375 10.875",
    stroke: "#747D90",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4065_35270"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFog);
export default __webpack_public_path__ + "static/media/fog.94f15b3f6a4e39575e742ed84fb0e56d.svg";
export { ForwardRef as ReactComponent };